




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import CameraUpload from '@/main-components/common/CameraUpload.vue';
import { GradeSchema } from '@/resource/grade/grade.model';
import { uploadImages } from '@/utils/grade';
import { axios } from '@/utils/axios';

@Component({
  components: {
    Modal,
    MainButton,
    CameraUpload,
  },
})
export default class ModalGradePaperSchema extends Vue {
  openModal: any = null;
  closeModal: any = null;

  @Prop({ required: true })
  gradeSchema: GradeSchema | null;

  @Prop({ required: true })
  gradePaperUuid: string;

  isLoading = false;
  imagesObject: { images: string[] } = { images: [] };

  @Watch('gradeSchema')
  gradeSchemaUpdated() {
    if (this.gradeSchema) {
      this.imagesObject = { images: this.gradeSchema.images };
    } else {
      this.imagesObject = { images: [] };
    }
  }

  mounted() {
    this.$emit('openModalGradePaperSchemaAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async saveSchema() {
    if (this.isLoading) return;
    this.isLoading = true;

    const images = await uploadImages(this.imagesObject.images);

    let response = null;
    if (this.gradeSchema) {
      response = await this.updateSchema(images);
    } else {
      response = await this.createSchema(images);
    }

    if (response) {
      this.$emit('refetchSchema');
      this.closeModal && this.closeModal();
    }

    this.isLoading = false;
  }

  async createSchema(images: string[]) {
    try {
      const { data } = await axios.post(
        `/grade-papers/${this.gradePaperUuid}/grade-schema`,
        {
          images,
        },
      );

      if (data) {
        this.$toasted.global.mainToast({
          message: 'Schema successfully added.',
        });
        return data;
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }

  async updateSchema(images: string[]) {
    try {
      const { data } = await axios.put(
        `/grade-papers/${this.gradePaperUuid}/grade-schema/${this.gradeSchema?.id}`,
        {
          images,
        },
      );

      if (data) {
        this.$toasted.global.mainToast({
          message: 'Schema successfully updated.',
        });
        return data;
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }
}
